/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskLabelCountAll } from './RiskLabelCountAll';
import {
  RiskLabelCountAllFromJSON,
  RiskLabelCountAllFromJSONTyped,
  RiskLabelCountAllToJSON,
} from './RiskLabelCountAll';

/**
 *
 * @export
 * @interface RiskProfileDimensionMatrixAll
 */
export interface RiskProfileDimensionMatrixAll {
  /**
   *
   * @type {Array<RiskLabelCountAll>}
   * @memberof RiskProfileDimensionMatrixAll
   */
  readonly riskLabelCounts: Array<RiskLabelCountAll>;
}

/**
 * Check if a given object implements the RiskProfileDimensionMatrixAll interface.
 */
export function instanceOfRiskProfileDimensionMatrixAll(value: object): value is RiskProfileDimensionMatrixAll {
  if (!('riskLabelCounts' in value) || value['riskLabelCounts'] === undefined) return false;
  return true;
}

export function RiskProfileDimensionMatrixAllFromJSON(json: any): RiskProfileDimensionMatrixAll {
  return RiskProfileDimensionMatrixAllFromJSONTyped(json, false);
}

export function RiskProfileDimensionMatrixAllFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RiskProfileDimensionMatrixAll {
  if (json == null) {
    return json;
  }
  return {
    riskLabelCounts: (json['risk_label_counts'] as Array<any>).map(RiskLabelCountAllFromJSON),
  };
}

export function RiskProfileDimensionMatrixAllToJSON(
  value?: Omit<RiskProfileDimensionMatrixAll, 'riskLabelCounts'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
